<div class="store" (click)="onClick()">
  <div class="store__icon">
    <lds-icon name="shopping" size="xl" appearance="inherit"></lds-icon>
  </div>
  <div class="store__text">
    Browse the latest from the <strong>MPM Store</strong>.
  </div>
</div>
